/**
 * Created by Pankaj on 25-Oct-2019
 */

import {IPolyBetLineConfig, PolyBetLine} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {RomanEmpireEvents} from "../../events/RomanEmpireEvents";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {LineSprite} from "./LineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";


export interface IShineMask {
    x: number,
    y: number,
    scaleX: number,
    scaleY: number,
    width: number,
    textureStr: string
}

export class RomanEmpirePolyBetLine extends PolyBetLine {
    private _name: string;

    constructor(index: number, numberPosition: number[], betLineData: number[], config: IPolyBetLineConfig) {
        super(index, numberPosition, betLineData, config);
        this._name = "betLineContainer_" + index;
    }

    /**
     * Override parent function to draw bet lines from sprites and dispatch bet line sprite data and event
     * for later use in initial win line shine and individual win line shine.
     * @param numberPosition
     * @param betLineData
     * @param config
     */
    protected draw(numberPosition: number[], betLineData: number[], config: IPolyBetLineConfig): void {
        let sprite: PIXI.Sprite = new LineSprite();
        sprite.anchor.set(0, 0);
        sprite.x = RomanEmpireGameConfig.instance.REEL_AREA_POS_X + 5;
        sprite.width = RomanEmpireGameConfig.instance.REEL_AREA_WIDTH;

        const symbolHeight: number = RomanEmpireGameConfig.instance.SYMBOL_HEIGHT,
            reelPosY: number = RomanEmpireGameConfig.instance.REEL_AREA_POS_Y,
            symbolBottomPadding: number = RomanEmpireGameConfig.instance.SYMBOL_BOTTOM_PADDING;

        switch (this.index) {
            case 1:
                sprite.texture = GameResources.getTextures("Betline_" + this.index)[0];
                sprite.y = (reelPosY + symbolHeight / 2) * 2 + 9;
                sprite.scale.x = sprite.scale.x - 0.01;
                break;
            case 2:
                sprite.texture = GameResources.getTextures("Betline_" + (this.index - 1))[0];
                sprite.y = reelPosY + symbolHeight / 2;
                sprite.scale.x = sprite.scale.x - 0.01;
                break;
            case 3:
                sprite.texture = GameResources.getTextures("Betline_" + (this.index - 2))[0];
                sprite.y = (reelPosY + symbolHeight / 2) * 3 + 18;
                sprite.scale.x = sprite.scale.x - 0.01;
                break;
            case 4:
                sprite.texture = GameResources.getTextures("Betline_" + this.index)[0];
                sprite.scale.x = sprite.scale.x - 0.01;
                sprite.y = reelPosY + symbolHeight / 2;
                break;
            case 5:
                sprite.texture = GameResources.getTextures("Betline_" + (this.index - 1))[0];
                sprite.x = RomanEmpireGameConfig.instance.REEL_AREA_POS_X + 6;
                sprite.scale.x = sprite.scale.x - 0.01;
                sprite.y = reelPosY + (symbolHeight * 5 / 2) + (symbolBottomPadding * 5 / 2) + 8;
                sprite.scale.y = (sprite.scale.x + 0.01) * -1;
                break;
            case 6:
                sprite.texture = GameResources.getTextures("Betline_" + this.index)[0];
                sprite.y = reelPosY + symbolHeight / 2;
                sprite.scale.x = sprite.scale.x - 0.01;
                break;
            case 7:
                sprite.texture = GameResources.getTextures("Betline_" + (this.index - 1))[0];
                sprite.y = reelPosY + (symbolHeight * 5 / 2) + (symbolBottomPadding * 5 / 2) + 8;
                sprite.scale.y *= -1;
                sprite.scale.x = sprite.scale.x - 0.01; //TODO test
                break;
            case 8:
                sprite.texture = GameResources.getTextures("Betline_" + this.index)[0];
                sprite.x = RomanEmpireGameConfig.instance.REEL_AREA_POS_X + 4;
                sprite.scale.x = sprite.scale.x - 0.005;
                sprite.y = reelPosY + (symbolHeight / 2) * 3;
                break;
            case 9:
                sprite.texture = GameResources.getTextures("Betline_" + (this.index - 1))[0];
                sprite.scale.x = sprite.scale.x - 0.008;
                sprite.y = reelPosY + (symbolHeight * 3 / 2) + (symbolBottomPadding * 3 / 2) + 9;
                sprite.scale.y *= -1;
                break;
            case 10:
                sprite.texture = GameResources.getTextures("Betline_" + this.index)[0];
                sprite.scale.x = sprite.scale.x - 0.01;
                sprite.y = reelPosY + symbolHeight / 2;
                break;
            case 11:
                sprite.texture = GameResources.getTextures("Betline_" + (this.index - 1))[0];
                sprite.scale.x = sprite.scale.x - 0.007;
                sprite.y = reelPosY + (symbolHeight * 5 / 2) + (symbolBottomPadding * 5 / 2) + 10;
                sprite.scale.y *= -1;
                break;
            case 12:
                sprite.texture = GameResources.getTextures("Betline_" + 10)[0];
                sprite.scale.x = sprite.scale.x - 0.008;
                sprite.y = reelPosY + (symbolHeight * 3 / 2) + (symbolBottomPadding * 3 / 2) + 10;
                sprite.scale.y *= -1;
                break;
            case 13:
                sprite.texture = GameResources.getTextures("Betline_" + 10)[0];
                sprite.x = RomanEmpireGameConfig.instance.REEL_AREA_POS_X + 4;
                sprite.scale.x = sprite.scale.x - 0.01;
                sprite.y = (reelPosY + symbolHeight * 1.55) - 11;
                break;
            case 14:
                sprite.texture = GameResources.getTextures("Betline_" + 6)[0];
                sprite.y = reelPosY + (symbolHeight * 3 / 2) + (symbolBottomPadding * 3 / 2) + 8;
                sprite.scale.y *= -1;
                sprite.scale.x = sprite.scale.x - 0.01;
                break;
            case 15:
                sprite.texture = GameResources.getTextures("Betline_" + 6)[0];
                sprite.y = reelPosY + symbolHeight * 1.55 - 10;
                sprite.scale.x = sprite.scale.x - 0.01;
                break;
            case 16:
                sprite.texture = GameResources.getTextures("Betline_" + 8)[0];
                sprite.scale.x = sprite.scale.x - 0.01;
                sprite.y = reelPosY + symbolHeight / 2;
                break;
            case 17:
                sprite.texture = GameResources.getTextures("Betline_" + 8)[0];
                sprite.scale.x = sprite.scale.x - 0.01;
                sprite.y = reelPosY + (symbolHeight * 5 / 2) + (symbolBottomPadding * 5 / 2) + 8;
                sprite.scale.y *= -1;
                break;
            case 18:
                sprite.texture = GameResources.getTextures("Betline_" + this.index)[0];
                sprite.x = RomanEmpireGameConfig.instance.REEL_AREA_POS_X + 5;
                sprite.scale.x = sprite.scale.x - 0.01;
                sprite.y = reelPosY + symbolHeight / 2;
                break;
            case 19:
                sprite.texture = GameResources.getTextures("Betline_" + (this.index - 1))[0];
                sprite.scale.x = sprite.scale.x - 0.01;
                sprite.y = reelPosY + (symbolHeight * 5 / 2) + (symbolBottomPadding * 5 / 2) + 8;
                sprite.scale.y *= -1;
                break;
            case 20:
                sprite.texture = GameResources.getTextures("Betline_" + this.index)[0];
                sprite.scale.x = sprite.scale.x - 0.01;
                sprite.y = reelPosY + symbolHeight / 2;
                break;
            default:
                break;
        }

        this.addChild(sprite);
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name).addChild(this);
        const maskPos: IShineMask = {
            x: sprite.x,
            y: sprite.y,
            scaleX: sprite.scale.x,
            scaleY: sprite.scale.y,
            width: sprite.width,
            textureStr: sprite.texture.textureCacheIds[0]
        };
        EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_LINE_SHINE_MASK_CREATED, this.index, maskPos));
        this.alpha = 0;
    }

    /**
     * Override parent class function to hide Bet line win amount and shadow.
     */
    protected hideAll(): void {
        super.hideAll();
        EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.HIDE_WIN_LINE_AMOUNT));
    }
}

